/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class generalledger extends IceEntity {
  patient_ledger_key: string = "";
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  src_key: string = "";
  src_type: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
  service_payment_reference_key: string = "";
  ledger_date: any = NaN;
  debit: number = 0.0;
  credit: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "GENERAL_LEDGER";
  }
}
